import React from "react"
import Format from "../components/ExtraPages/Format"
import styled from "styled-components"
import { IoMdOpen } from "react-icons/io"
import antiragging from "../uploads/AntiRagging/anti-ragging.pdf"

const AntiRagging = () => {
  const heading = 'Anti-Ragging'
  return (
      <Format heading={heading}>
        <Outerdiv>
            <Form>
                <p>Step by step instructions to filling anti ragging affidavit:</p>
                <a href={antiragging} target='_blank' rel="noreferrer"><Button>Anti-Ragging<IoMdOpen /></Button></a>
            </Form>
            <Form>
                <p>Visit the following link to fill Online Anti-ragging form</p>
                <a href='https://amanmovement.org/registration/public/amanmovement/raggingmain.html#affidavit' target='_blank' rel="noreferrer"><Button>Fill online<IoMdOpen /></Button></a>
            </Form>
        </Outerdiv>
      </Format>
  )
}

export default AntiRagging

const Outerdiv = styled.div`
  display: flex;
  flex-direction: column;

  a{
      text-decoration: none;
  }
`

const Form = styled.div`
    display: flex;
    flex-direction: row;
    margin: var(--spacer-3);
    @media only screen and (max-width : 544px) {
    flex-direction: column;    
  }
`

const Button = styled.div`
  width: 10rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  height: auto;
  cursor: pointer;
  color: var(--textWhite);
  background: var(--primaryRedHover);
  margin: 0 var(--spacer-3);
  border-radius: 3px;
  padding: var(--spacer-2);
  transition: all ease-in 0.2s;

  :hover{
    background: var(--primaryRed);
    box-shadow:  0 5px 11px 0 rgba(0,0,0,0.18), 0 4px 15px 0 rgba(0,0,0,0.15);
    z-index: 100;
  }
`
